// extracted by mini-css-extract-plugin
module.exports = {"wrap":"index_wrap_18y9Z","title":"index_title_3sgQo","content":"index_content_sOje2","searchInput":"index_searchInput_37yF6","table":"index_table_s1KEF"};